export enum FileAdapterEvent {
  ready = 'ready',
  operation = 'operation',
  ack = 'ack',
  retry = 'retry',
  change = 'change'
}
